import React, { useEffect } from "react";
import Storage from "../../services/storage.service";
import SpinnerTimeLoader from "../../views/shared/timeLoading";
import User from "../../services/user.service";

const EligibilitySuccess = props => {
  
  const eligibilityDone = () => {
    let flags = Storage.get("flags");
    flags.IsEligible = true;
    Storage.set("flags", flags);
    User.fetchFlowStatus();
  };

  useEffect(() => {
    eligibilityDone();
  }, [])

  return (
    <div className="stf-eligibility-cntnr stf-eligibility-cntnr-margin">
      <SpinnerTimeLoader />
    </div>
  );
};
export default EligibilitySuccess;
